/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE", "EXPERIMENTAL_OVERRIDE")

package features.getPublicQrCodeScanToken.internal

import features.getPublicQrCodeScanToken.models.GetPublicQrCodeScanTokenResponseModel
import features.getPublicQrCodeScanToken.models.PublicQrCodeScanTokenRequest
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.io.toModel

internal class GetPublicQrCodeScanTokenServiceImpl : GetPublicQrCodeScanTokenService {

    private val getPublicQrCodeScanTokenRequest = GetPublicQrCodeScanTokenRequest()

    override suspend fun getPublicQrCodeScanToken(
        overrideHeaders : Map<String, String>?,
        publicQrCodeScanTokenRequest: PublicQrCodeScanTokenRequest    ): Result<GetPublicQrCodeScanTokenResponseModel> {
        return getPublicQrCodeScanTokenRequest.getPublicQrCodeScanToken(
            overrideHeaders = overrideHeaders,
            publicQrCodeScanTokenRequest = publicQrCodeScanTokenRequest        ).toModel()
    }
}
